import React from "react";
import TeamLogo from "./TeamLogo";
import { formatTeamScore, hasLiveScores } from "../../utility/matchScore";

/**
 * Sport-agnostic live/upcoming/ended score panel.
 * Uses API `scores` array — no hardcoded cricket UI.
 */
export default function MatchLiveScorePanel({ game, phase }) {
  if (!game) return null;

  if (phase === "live") {
    return (
      <div className="tvContent">
        <p className="fs14 titleText">Live</p>
        {hasLiveScores(game) ? (
          <div className="scoreOverviewPoint fs13">
            <p>
              <TeamLogo
                teamName={game.home_team}
                logoUrl={game.home_team_logo}
                size="sm"
                alt={game.home_team}
              />
              <span>{formatTeamScore(game, game.home_team, "0")}</span>
            </p>
            <span>:</span>
            <p>
              <span>{formatTeamScore(game, game.away_team, "0")}</span>
              <TeamLogo
                teamName={game.away_team}
                logoUrl={game.away_team_logo}
                size="sm"
                alt={game.away_team}
              />
            </p>
          </div>
        ) : (
          <span className="fs15 infoText">Live — score updating</span>
        )}
      </div>
    );
  }

  if (phase === "upcoming") {
    return (
      <div className="tvContent">
        <span className="fs15 infoTextselected">
          This match is scheduled and will begin soon.
        </span>
      </div>
    );
  }

  if (phase === "ended") {
    return (
      <div className="tvContent">
        {hasLiveScores(game) ? (
          <div className="scoreOverviewPoint fs13">
            <p>
              <TeamLogo
                teamName={game.home_team}
                logoUrl={game.home_team_logo}
                size="sm"
                alt={game.home_team}
              />
              <span>{formatTeamScore(game, game.home_team, "—")}</span>
            </p>
            <span>:</span>
            <p>
              <span>{formatTeamScore(game, game.away_team, "—")}</span>
              <TeamLogo
                teamName={game.away_team}
                logoUrl={game.away_team_logo}
                size="sm"
                alt={game.away_team}
              />
            </p>
            <span className="fs13 infoText mt-2 d-block">Final</span>
          </div>
        ) : (
          <span className="fs15 infoTextselected">This match has ended.</span>
        )}
      </div>
    );
  }

  return (
    <div className="tvContent">
      <span className="fs15 infoText">Match status unavailable.</span>
    </div>
  );
}
